import { createFileRoute } from "@tanstack/react-router";
import { CompanyDetailsPage } from "@/components/organisations/[id]";
import { adminExtend } from "@/lib/auth-client";

export const Route = createFileRoute("/dashboard/_admin/company/$companyId/")({
  loader: async ({ params }) => {
    // Set the active organization, but don't fail if it errors
    try {
      await adminExtend.setActiveOrganization({
        organizationId: params.companyId,
      });
    } catch (error) {
      // TODO return to somewhere else
      console.error("Failed to set active organization:", error);
    }

    const res = await adminExtend.getFullOrganization({
      organizationId: params.companyId,
    });
    // Cast to expected type as the structure is compatible enough for now
    return res.data as unknown;
  },
  component: Component,
  staticData: {
    title: "Company Details",
    parent: { title: "Company Management", path: "/dashboard/company" },
  },
});

function Component() {
  const data = Route.useLoaderData();

  return <CompanyDetailsPage data={data} />;
}
